import { render, staticRenderFns } from "./Login1.vue?vue&type=template&id=2517e458&scoped=true&"
import script from "./Login1.vue?vue&type=script&lang=js&"
export * from "./Login1.vue?vue&type=script&lang=js&"
import style0 from "./Login1.vue?vue&type=style&index=0&id=2517e458&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2517e458",
  null
  
)

export default component.exports